//https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
import {getToken} from "../Utils/Common";
import {sha256} from 'js-sha256';

// export function getUserInfo() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/user0`,
//         {
//             method: 'GET',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(response => response.json())
// }
//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"
let apilink = process.env.REACT_APP_BACKEND_API_URI

export function sendEmail(emaildetails) {
    const link = apilink + "email/" + "sendemail";
    emaildetails.token = getToken()
    return fetch(`${link}`,
        {
            method: 'POST',
            headers: {
                //"authorisation":getToken(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(emaildetails)
        })
        .then(response => response.json())
}


export function getUserInfo() {
    //alert(JSON.stringify(getToken()),"222")
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}getuserinfo`,
        {
            method: 'POST',
            headers: {
                'Authorization': getToken(),
            },
        })
        .then(response => response.json())
}

export function getOnlyUserEmail(user_id) {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}getonlyuseremail`,
        {
            method: 'POST',
            headers: {
                'Authorization': getToken(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({user_id: user_id})
        })
        .then(response => response.json())
}

export function readUserInfo(data, setSuccessMessage) {
    if (data.message.co !== undefined) {
        alert(data.message.co);
    } else if (data.message.new_pwd !== undefined) {
        alert(data.message.new_pwd);
    } else {
        setSuccessMessage(data.message);
    }

}

// export function putUserInfo(userInfo) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/users`, {
//         method: 'PUT',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': 'Bearer ' + getToken(),
//         },
//         body: JSON.stringify(userInfo)
//     })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(function (data) {
//             let message = data;
//             return message;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

export function putUserInfo(userInfo) {
    if (userInfo.new_pwd) {
        const newHashedPwd = hash(userInfo.new_pwd);
        userInfo.new_pwd = newHashedPwd
    }
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}saveuserdata`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken(),
        },
        body: JSON.stringify(userInfo)
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            let message = data;
            return message;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

// export function getUsersData() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/users`,
//
//         {
//             method: 'GET',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(response => response.json())
// }

export function getUsersData() {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}getusersdata`,
        {
            method: 'GET',
            headers: {
                'Authorization': getToken(),
            },
            //body: JSON.stringify(cred)
        })
        .then(response => response.json())
}

// export function getDetails(userDetailsLink) {
//     userDetailsLink = userDetailsLink.replace(`${process.env.REACT_APP_ENDPOINT_API}`, `${process.env.REACT_APP_BASE_URI}`);
//     return fetch(userDetailsLink,
//         {
//             method: 'GET',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(response => response.json())
// }

export function getDetails(userDetailsLink) {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}getoneuserdetail`,
        {
            method: 'POST',
            headers: {
                'Authorization': getToken(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({"cred": userDetailsLink})
        })
        .then(response => response.json())
}

// export function changeUserStatus(link) {
//     link = link.replace(`${process.env.REACT_APP_ENDPOINT_LOGINSYSTEM}`, `${process.env.REACT_APP_ENDPOINT_STATUS}`);
//     console.log(link);
//     return fetch(link,
//         {
//             body: JSON.stringify({}),
//             method: 'POST',
//             headers: {
//                 // 'Content-Type': 'application/x-www-form-urlencoded',
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(data => data)
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

export function changeUserStatus(userStatusLink) {

    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}changeuserstatus`,
        {
            body: JSON.stringify({"cred": userStatusLink}),
            method: 'POST',
            headers: {
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Content-Type': 'application/json',
                'Authorization': getToken()
            }
        })
        .then(function (response) {
            return response.json();
        })
        .then(data => data)
        .catch((error) => {
            console.error('Error:', error);
        });
}

// export function saveUserData(userData) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/users`, {
//         method: "POST",
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': 'Bearer ' + getToken(),
//         },
//         body: JSON.stringify(userData)
//     })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(function (data) {
//             return data;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

export function saveUserData(userData) {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}saveuserdata`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken(),
        },
        body: JSON.stringify(userData)
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

// export function loginUser(credentials) {
//     credentials['client_id'] = process.env.REACT_APP_CLIENTID;
//     credentials['client_secret'] = process.env.REACT_APP_CLIENTSECRET;
//     return fetch(`${process.env.REACT_APP_BASE_URI}/login`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// }

// export async function loginUser(credentials) {
//     //hashing pasword
//     const hashedPwd = hash(credentials["pwd"]);
//     credentials["pwd"]=hashedPwd
//     const link = "https://s1p70opjhg.execute-api.eu-central-1.amazonaws.com/dev";
//     return fetch(`${link}/signinrevagain`, {
// export function loginUser(credentials) {
//     credentials['client_id'] = process.env.REACT_APP_CLIENTID;
//     credentials['client_secret'] = process.env.REACT_APP_CLIENTSECRET;
//     return fetch(`${process.env.REACT_APP_BASE_URI}/login`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// }

export async function loginUser(credentials) {
    //hashing pasword
    const hashedPwd = hash(credentials["pwd"]);
    credentials["pwd"] = hashedPwd
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}signinrev`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
    })
        .then(data => data.json())
    //data => data.json())
}


function hash(string) {
    const myHash = sha256(string)
    return myHash
}

// export function logoutUser() {
//     let credentials = {};
//     credentials['client_id'] = process.env.REACT_APP_CLIENTID;
//     credentials['client_secret'] = process.env.REACT_APP_CLIENTSECRET;
//     credentials['access_token'] = getToken();
//     return fetch(`${process.env.REACT_APP_BASE_URI}/logout`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// }

export function logoutUser() {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({"token": getToken()})
    })
        .then(data => data.json())
}

// export function otpCode(credentials) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/otp`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// }

export async function otpCode(credentials) {
    const hashedPwd = hash(credentials["pwd"]);
    credentials["pwd"] = hashedPwd
    const hashedOtp = hash(credentials["otp"]);
    credentials["otp"] = hashedOtp
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}checkotp`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
    })
        .then(data => data.json())
}

// export function resetPwd(credentials) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/resetpwd`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => {
//             if (data.status === 200) {
//                 return 'ok';
//             }
//             if (data.status === 400) {
//                 return 'error';
//             }
//         })
//         .catch((error) => {
//             console.log(error);
//         });
// }

export async function resetPwd(credentials) {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}passwordForget`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
    })
        .then(data => {
            return data.json()
        })
        .catch((error) => {
            console.log(error);
        });
       }


export async function resetPassword(resetLink) {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}resetpassword?resetlink=${resetLink}`,
        {
            method: 'GET',
            headers: {
                'Authorization': getToken(),
            },
        }).then(response => response.json())
}

// export function resetPassword(resetLink) {
//     return fetch(resetLink,
//         {
//             method: 'POST',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         }).then(response => response.json())
// }

// export function isUserDataDuplicate(value, userData) {
//     let link = `${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/checkduplication/`
//     link = link.concat(value);
//     return fetch(link,
//         {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//             body: JSON.stringify(userData)
//         })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(data => data)
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

export function isUserDataDuplicate(value, userData) {
    let info = {"value": value, "userData": userData}
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}checkduplication`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': getToken(),
            },
            body: JSON.stringify(info)
        })
        .then(function (response) {
            return response.json();
        })
        .then(data => data)
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function deleteSingleUser(o) {
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}deleteuser`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': getToken(),
            },
            body: JSON.stringify(o)
        })
        .then(function (response) {
            return response.json();
        })
        .then(data => data)
        .catch((error) => {
            console.error('Error:', error);
        });

}

// export function getcompanyinfos() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/companyinfos`, {
//         method: 'GET',
//         headers: {
//             'Authorization': 'Bearer ' + getToken(),
//         },
//     })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(function (data) {
//             return data;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }

export function getcompanyinfos() {
    let info = {}
    return fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}getcompanyinfos`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken(),
        },
        body: JSON.stringify(info)
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

// //https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
// import {getToken} from "../Utils/Common";
//
// export function getUserInfo() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/user0`,
//         {
//             method: 'GET',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(response => response.json())
// }
//
// export function readUserInfo(data, setSuccessMessage) {
//     if (data.message.co !== undefined) {
//         alert(data.message.co);
//     }
//
//     else if (data.message.new_pwd !== undefined)
//     {
//         alert(data.message.new_pwd);
//     }
//     else {
//         setSuccessMessage(data.message);
//     }
//
// }
//
//
// export function putUserInfo(userInfo) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/users`, {
//         method: 'PUT',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': 'Bearer ' + getToken(),
//         },
//         body: JSON.stringify(userInfo)
//     })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(function (data) {
//             let message = data;
//             return message;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }
//
// export function getUsersData() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/users`,
//
//         {
//             method: 'GET',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(response => response.json())
// }
//
// export function getDetails(userDetailsLink) {
//     userDetailsLink = userDetailsLink.replace(`${process.env.REACT_APP_ENDPOINT_API}`, `${process.env.REACT_APP_BASE_URI}`);
//     return fetch(userDetailsLink,
//         {
//             method: 'GET',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(response => response.json())
// }
//
//
// export function changeUserStatus(link) {
//     link = link.replace(`${process.env.REACT_APP_ENDPOINT_LOGINSYSTEM}`, `${process.env.REACT_APP_ENDPOINT_STATUS}`);
//     console.log(link);
//     return fetch(link,
//         {
//             body: JSON.stringify({}),
//             method: 'POST',
//             headers: {
//                 // 'Content-Type': 'application/x-www-form-urlencoded',
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(data => data)
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }
//
//
// export function saveUserData(userData) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/users`, {
//         method: "POST",
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': 'Bearer ' + getToken(),
//         },
//         body: JSON.stringify(userData)
//     })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(function (data) {
//             return data;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }
//
//
// export function loginUser(credentials) {
//     credentials['client_id'] = process.env.REACT_APP_CLIENTID;
//     credentials['client_secret'] = process.env.REACT_APP_CLIENTSECRET;
//     return fetch(`${process.env.REACT_APP_BASE_URI}/login`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// }
//
//
// export function logoutUser() {
//     let credentials = {};
//     credentials['client_id'] = process.env.REACT_APP_CLIENTID;
//     credentials['client_secret'] = process.env.REACT_APP_CLIENTSECRET;
//     credentials['access_token'] = getToken();
//     return fetch(`${process.env.REACT_APP_BASE_URI}/logout`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// }
//
// export function otpCode(credentials) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/otp`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// }
//
// export function resetPwd(credentials) {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/resetpwd`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => {
//             if (data.status === 200) {
//                 return 'ok';
//             }
//             if (data.status === 400) {
//                 return 'error';
//             }
//         })
//         .catch((error) => {
//             console.log(error);
//         });
// }
//
// export function resetPassword(resetLink) {
//     return fetch(resetLink,
//         {
//             method: 'POST',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         }).then(response => response.json())
// }
//
// export function isUserDataDuplicate(value, userData) {
//     let link = `${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/checkduplication/`
//     link = link.concat(value);
//     return fetch(link,
//         {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//             body: JSON.stringify(userData)
//         })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(data => data)
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }
//
//
//
//
//
// export function deleteSingleUser(uid) {
//     let link = '/api/logsystem/v1/resources/delete/' + uid;
//     return fetch(`${process.env.REACT_APP_BASE_URI}`+ link,
//
//         {
//             method: 'DELETE',
//             headers: {
//                 'Authorization': 'Bearer ' + getToken(),
//             },
//         })
//         .then(response => response.json())
// }
//
//
//
//
//
// export function getcompanyinfos() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/logsystem/v1/resources/companyinfos`, {
//         method: 'GET',
//         headers: {
//             'Authorization': 'Bearer ' + getToken(),
//         },
//     })
//         .then(function (response) {
//             return response.json();
//         })
//         .then(function (data) {
//             return data;
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
// }